import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class IDeliveryDocument {
  id: string | number;
  package_id: number;
  url: string;
  pdf_url: string;
  create_date: Date;
  type: string;
}

export class IDeliveryDocumentResponse {
  @Type(() => IDeliveryDocument)
  result: IDeliveryDocument;
}

export class IDeliveryDocumentListResponse extends IPagination {
  @Type(() => IDeliveryDocument)
  results: IDeliveryDocument[];
}

export class IDeliveryDocumentQueryDto extends IQueryPaginationDto {
  packageId?: string;
}

export class IDeliveryDocumentDownloadUrlResponse {
  downloadUrl: string;
}
